import ListViewCtrl from "../util/ListViewCtrl";

export default class OdberneMiestoOpravnenaOsobaListCtrl extends ListViewCtrl {

  static $inject = ["itemOpravnenaOsoba","OdberneMiestoService", "OdberneMiestoOpravnenaOsobaService"];
  constructor(itemOpravnenaOsoba, OdberneMiestoService, OdberneMiestoOpravnenaOsobaService){
  	super(itemOpravnenaOsoba);
    this.OdberneMiestoService = OdberneMiestoService;
    this.itemOpravnenaOsoba = itemOpravnenaOsoba;
    this.OdberneMiestoOpravnenaOsobaService = OdberneMiestoOpravnenaOsobaService;
  }

  remove(id) {
  	if(this.OdberneMiestoOpravnenaOsobaService.remove(id)) {
      this.itemOpravnenaOsoba.result = this.itemOpravnenaOsoba.result.filter(function( obj ) {
          return obj.id !== id;
      });
    }
  }



}


// WEBPACK FOOTER //
// ./src/OdberneMiesto/OdberneMiestoOpravnenaOsobaListCtrl.js